import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography, Button, CircularProgress, Box } from '@mui/material';

const NetsuiteLoadingDialog = ({
  open,
  message,
  loading = false,
  loadingMessage = 'Saving. Please wait...',
  onConfirm,
  onCancel,
  onClose,
  onCancelClick,
  showCancel = true,
  showNo = false,
  confirmLabel = 'Yes',
  noLabel = 'No',
  cancelLabel = 'Cancel',
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        {loading ? (
          <Box display="flex" alignItems="center" gap={2}>
            <CircularProgress size={20} />
            <Typography>{loadingMessage}</Typography>
          </Box>
        ) : (
          <Typography>{message}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} disabled={loading} variant="contained" color="primary">
          {loading ? 'Submitting...' : confirmLabel}
        </Button>
        {showNo && (
          <Button onClick={onCancel} disabled={loading} variant="contained" color="secondary">
            {noLabel}
          </Button>
        )}
        {showCancel && (
          <Button onClick={onCancelClick || onClose} disabled={loading} variant="contained" color="warning">
            {cancelLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default NetsuiteLoadingDialog;
